<template>
  <validation-form @on-submit="sendNotifications">
    <md-card>
      <md-card-content>
        <filter-options
          v-if="!hasValidRole(userRole, [Role.Teacher, Role.Counselor])"
          :data.sync="formData"
          :validations="sendMailValidations"
          :hasCheckBox="hasCheckBox"
          :serverValidations="serverValidations"
          ref="filterOptionsRef"
        ></filter-options>
        <filter-by-teacher
          v-if="hasValidRole(userRole, Role.Teacher)"
          :data.sync="formData"
          :validations="sendMailValidations"
          :hasCheckBox="hasCheckBox"
          :serverValidations="serverValidations"
          ref="filterOptionsRef"
        ></filter-by-teacher>
        <filter-by-counselor
          v-if="hasValidRole(userRole, Role.Counselor)"
          :data.sync="formData"
          :hasCheckBox="hasCheckBox"
          :serverValidations="serverValidations"
          ref="filterOptionsRef"
        ></filter-by-counselor>
        <div class="md-layout">
          <div class="md-layout-item md-size-25 md-small-size-100">
            <validation-field>
              <label>{{ $t("communication.template") }}</label>
              <md-select
                name="template"
                v-model="formData.template"
                @md-selected="selectTemplate"
                id="template"
              >
                <md-option
                  :value="template._id"
                  v-for="(template, templateIndex) in templateList"
                  :key="templateIndex"
                  >{{ template.name }}
                </md-option>
              </md-select>
            </validation-field>
          </div>

          <div class="md-layout-item md-size-25 md-small-size-100">
            <md-field>
              <label>{{ $t("communication.choose_attach_file") }}</label>
              <md-file
                @md-change="handleFileChanged($event)"
                v-model="formData.attachments[0].name"
              ></md-file>
            </md-field>
          </div>

          <div class="md-layout-item md-size-25 md-small-size-100">
            <validation-field
              :validations="sendMailValidations.title"
              name="title"
            >
              <label>{{ $t("communication.title") }}</label>
              <md-input v-model="formData.title" required></md-input>
              <span
                style="top: 40px"
                class="md-error"
                v-if="serverValidations.title"
              >
                {{ serverValidations.title }}
              </span>
            </validation-field>
          </div>
          <div
            class="md-layout-item md-size-100 md-small-size-100 variable-layout"
          >
            <div class="variable-system" style="margin-top: 20px">
              <span
                class="variable-item"
                v-for="(variable_system, variable) in VARIABLE_SYSTEM"
                :key="variable"
              >
                {{ variable_system.key }}
                = {{ variable_system.value }}
              </span>
            </div>
          </div>
          <div
            class="md-layout-item md-size-100 md-small-size-100 variable-layout"
          >
            <div class="variable-config">
              <div
                class="variable-item"
                v-for="(variable_config, variableIndex) in formData.variables"
                :key="variableIndex"
              >
                <validation-field>
                  {{ variable_config.key }} =
                  <input v-model="variable_config.value" />
                  <span class="md-error" v-if="!variable_config.value">{{
                    variableConfigValidation
                  }}</span>
                </validation-field>
              </div>
            </div>
          </div>
          <div class="editor-block">
            <validation-field name="contents">
              <Editor
                class="md-layout"
                :placeholder="$t('communication.please_enter_content')"
                v-model="formData.contents"
                :api-key="EDITOR_API_KEY"
                :init="{
                  height: 200,
                  menubar: true,
                  plugins: EDITOR_PLUGINS,
                  toolbar: EDITOR_TOOLBAR
                }"
              />
              <span class="md-error" v-if="serverValidations.contents">
                {{ serverValidations.contents }}
              </span>
            </validation-field>
          </div>
        </div>
      </md-card-content>
    </md-card>
    <footer class="flex justify-center">
      <md-button @click="goToPreviousPage">Cancel</md-button>
      <md-button class="md-success ml-4" type="submit">Send</md-button>
    </footer>
  </validation-form>
</template>
<script>
import FilterOptions from "./FilterOptions/index";
import FilterByTeacher from "./FilterOptions/FillterByTeacher";
import FilterByCounselor from "./FilterOptions/FilterByCounselor";
import { validations } from "@/validations/communication";
import { hasValidRole } from "@/helpers/role-helper";

import {
  EDITOR_PLUGINS,
  EDITOR_TOOLBAR,
  EDITOR_API_KEY,
  REMOVE_VIETNAMESE_TONES
} from "./Template/utils";
import { VARIABLE_SYSTEM } from "@/constants";
import Editor from "@tinymce/tinymce-vue";
import { postFileToS3 } from "@/helpers/aws-s3";
import AWSConst from "@/constants/AWS";
import omit from "lodash/omit";
import { Message, genErrMsgOj } from "@/helpers/utils";
import { service_paths } from "@/constants/Services";
import Role from "@/constants/Role";
import { hasHistory } from "@/helpers/utils";

export default {
  name: "SendEmail",
  components: { Editor, FilterOptions, FilterByTeacher, FilterByCounselor },
  props: ["formData", "userRole"],
  data() {
    return {
      EDITOR_API_KEY,
      Role,
      VARIABLE_SYSTEM,
      EDITOR_TOOLBAR,
      REMOVE_VIETNAMESE_TONES,
      hasCheckBox: true,
      EDITOR_PLUGINS,
      templateList: [],
      sendMailValidations: validations,
      variableConfigValidation: "",
      serverValidations: {},
      hasValidRole
    };
  },
  created() {
    this.getTemplates();
  },
  watch: {
    "formData.recipients": function() {
      this.serverValidations.recipients &&
        delete this.serverValidations.recipients;
    },
    "formData.title": function() {
      this.serverValidations.title && delete this.serverValidations.title;
    },
    "formData.contents": function() {
      this.serverValidations.contents && delete this.serverValidations.contents;
    },
    "formData.variables": {
      deep: true,
      handler: function() {}
    }
  },
  methods: {
    goToPreviousPage() {
      hasHistory() ? this.$router.go(-1) : this.$router.push("/");
    },
    handleFileChanged(event) {
      this.formData.attachments[0].fileRaw = this.changeFileName(event[0]);
    },
    changeFileName(file) {
      return new File([file], file.name.replace("-", "_"), { type: file.type });
    },
    uploadFileToS3(file) {
      return postFileToS3(
        `${AWSConst.S3_COMMUNICATION_UPLOAD_PATH}/template`,
        file
      );
    },
    async beforeSendNotification() {
      let formData = { ...this.formData };
      formData.attachments[0].name = this.REMOVE_VIETNAMESE_TONES(
        formData.attachments[0].name
      );
      if (hasValidRole(this.userRole, Role.Counselor)) {
        formData.recipients = "Counselor";
        formData.filter_by = "Counselor";
      }
      formData.variables.forEach(item => {
        if (item && !item.value) {
          this.variableConfigValidation = this.$t(
            "communication.the_field_is_required"
          );
          return;
        } else this.variableConfigValidation = "";
      });
      if (formData.attachments[0].fileRaw) {
        formData.attachments[0].src = await this.uploadFileToS3(
          formData.attachments[0].fileRaw
        );
        this.$nextTick(() => {
          formData.attachments[0] = omit(formData.attachments[0], "fileRaw");
        });
      }
      if (!formData.attachments[0].name) {
        formData.attachments = [];
      }
      switch (formData.filter_by) {
        case "Staff": {
          formData.staffs = formData.selectedList;
          break;
        }
        case "Grade": {
          formData.grades = formData.selectedList;
          break;
        }
        case "Class": {
          formData.classes = formData.selectedList;
          break;
        }
        case "Student": {
          formData.students = formData.selectedList;
          break;
        }
        case "Program": {
          formData.programs = formData.selectedList;
          break;
        }
        case "Term": {
          formData.terms = formData.selectedList;
          break;
        }
        case "Counselor": {
          formData.counselors = this.formData.selectedList;
          break;
        }
      }
      return formData;
    },
    async sendNotifications() {
      let formData = Object.assign(
        { type: "email" },
        await this.beforeSendNotification()
      );
      if (this.variableConfigValidation) return;
      const errMsg = this.$t("communication.form_invalid");
      this.$axios
        .post(
          `${service_paths.communication_notification}/send`,
          formData,
          true,
          {},
          errMsg
        )
        .then(() => {
          Message.success(this.$t("common.successfully"));
          this.$emit("update-form-data");
        })
        .catch(error => {
          const errData = error.response?.data;

          if (errData) {
            const svErrMsgs = errData.messages;
            this.serverValidations = genErrMsgOj(svErrMsgs);
          }
        });
    },
    async getTemplates() {
      await this.$axios
        .get(`${service_paths.communication_template}`, { type: "email" })
        .then(response => {
          this.templateList = response.data.data;
        });
    },
    selectTemplate(e) {
      let selectedTemplate = this.templateList.find(
        template => template._id === e
      );
      if (selectedTemplate) {
        this.formData.attachments = selectedTemplate.attachments;
        this.formData.title = selectedTemplate.title;
        this.formData.contents = selectedTemplate.content;
        this.formData.variables = selectedTemplate.variables;
      }
    }
  }
};
</script>
<style lang="scss">
.tox .tox-collection__item-label {
  word-break: normal !important;
}
</style>
